module.exports = __webpack_public_path__ + "img/福原魁人.0c76d102.jpg";